import type { Province } from "@/store/types/province";
import { AlbertaIcon } from "./AlbertaIcon";
import { BritishColumbiaIcon } from "./BritishColumbiaIcon";
import { ManitobaIcon } from "./ManitobaIcon";
import { NewBrunswickIcon } from "./NewBrunswickIcon";
import { NewfoundLandIcon } from "./NewfoundLandIcon";
import { NovaScotiaIcon } from "./NovaScotiaIcon";
import { NorthWestIcon } from "./NorthWestIcon";
import { OntarioIcon } from "./OntarioIcon";
import { PrinceEdwardIcon } from "./PrinceEdwardIcon";
import { QuebecIcon } from "./QuebecIcon";
import { SaskatchewanIcon } from "./SaskatchewanIcon";
import { YukonIcon } from "./YukonIcon";
import { NunavutIcon } from "./NunavutIcon";

interface ProvinceIconData {
  province: Province;
  component: any;
}

export const provinceIcons: ProvinceIconData[] = [
  {
    province: "PEI",
    component: PrinceEdwardIcon,
  },
  {
    province: "NS",
    component: NovaScotiaIcon,
  },
  {
    province: "NB",
    component: NewBrunswickIcon,
  },
  {
    province: "NL",
    component: NewfoundLandIcon,
  },
  {
    province: "QC",
    component: QuebecIcon,
  },
  {
    province: "ON",
    component: OntarioIcon,
  },
  {
    province: "MB",
    component: ManitobaIcon,
  },
  {
    province: "AB",
    component: AlbertaIcon,
  },
  {
    province: "BC",
    component: BritishColumbiaIcon,
  },
  {
    province: "NU",
    component: NunavutIcon,
  },
  {
    province: "NT",
    component: NorthWestIcon,
  },
  {
    province: "SK",
    component: SaskatchewanIcon,
  },
  {
    province: "YT",
    component: YukonIcon,
  },
];
